import { Box, Typography } from "@mui/material";

export function SourceQuestionLabel(props: {
  baseLabel: string;
  isMandatory: boolean;
  source: string;
}) {
  const { baseLabel, isMandatory, source } = props;

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "baseline",
        columnGap: 1,
        rowGap: 0,
        flexWrap: "wrap",
        minWidth: 0,
        fontWeight: 500,
        mb: 0.5,
      }}
    >
      <span>
        {baseLabel}
        {isMandatory ? " *" : ""}
      </span>
      <Typography
        component="span"
        sx={{
          color: "grey.600",
          fontWeight: 500,
          overflowWrap: "anywhere",
          wordBreak: "break-word",
          minWidth: 0,
        }}
      >
        Source: {source}
      </Typography>
    </Box>
  );
}
